import React from 'react';
import Mark from './Mark';
export default function MinuteMark(props) {
  return /*#__PURE__*/React.createElement(Mark, props);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-clock/dist/esm/MinuteMark.js
// module id = null
// module chunks = 